import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { EnrollmentComponent } from './enrollment.component';
import { EnrollmentDetailComponent } from './enrollment-detail.component';
import { EnrollmentPopupComponent } from './enrollment-dialog.component';
import { EnrollmentDeletePopupComponent } from './enrollment-delete-dialog.component';
import { EnrollmentPayPopupComponent } from './enrollment-pay-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class EnrollmentResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'validSince,desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const enrollmentRoute: Routes = [
    {
        path: 'enrollment',
        component: EnrollmentComponent,
        resolve: {
            'pagingParams': EnrollmentResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        }
    }, {
        path: 'enrollment/:id',
        component: EnrollmentDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        }
    }
];

export const enrollmentPopupRoute: Routes = [
    {
        path: 'enrollment-new',
        component: EnrollmentPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'enrollment-new-for-student/:studentId',
        component: EnrollmentPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'enrollment/:id/edit',
        component: EnrollmentPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'enrollment/:id/delete',
        component: EnrollmentDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'enrollment/:id/pay',
        component: EnrollmentPayPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.enrollment.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment.route.ts